export const translate = {
    'en-GB': require('./en-GB.json'),
    'sq-AL': require('./sq-AL.json'),
};